import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { ToggleButton } from '@material-ui/core'

const StyledToggleButton = styled(ToggleButton)`
  && {
    border-radius: 4px;
    background: #f4f6f8;
    border: 0 !important;
    text-transform: none;

    display: flex;
    height: 28px;
    padding: 4px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    color: #000;

    &.Mui-selected {
      background: var(--mcg-white, #fff);
      &:hover {
        background: var(--mcg-white, #fff) !important;
      }
    }

    &:hover {
      background: #f4f6f8 !important;
    }

    &.Mui-disabled {
      color: #b0b7c3 !important;
      opacity: 0.55;
      cursor: not-allowed;
      pointer-events: auto;
    }

    &.Mui-disabled svg,
    &.Mui-disabled p,
    &.Mui-disabled .MuiTypography-root {
      color: #b0b7c3 !important;
    }
  }
`

const CoreToggleButton = ({ children, ...props }) => {
  return <StyledToggleButton {...props}>{children}</StyledToggleButton>
}

CoreToggleButton.propTypes = {
  children: PropTypes.node,
  value: PropTypes.any,
}

export default CoreToggleButton
